import { graphql } from '@search/gql-client/src';

export default graphql`
    query PlacementOfferQuery($userId: String!, $offerId: String!) {
        getPlacementOffer(userId: $userId, offerId: $offerId) {
            item {
                status
                offer {
                    id
                    stats {
                        offerViews
                        phoneViews
                    }
                    vasList {
                        vas
                        duration
                        condition
                        status
                        until {
                            formattedFull
                            formattedAutoDate
                            formattedDateAndTime
                        }
                    }
                }
            }
        }
    }
`;
